<template>
  <section class="author-content-section" :aria-labelledby="headingId">
    <header class="author-content-section__header">
      <h2 :id="headingId" class="author-content-section__title">
        {{ title }}
        <span class="author-content-section__count" aria-hidden="true">{{ cards.length }}</span>
      </h2>
    </header>

    <div class="author-content-section__grid">
      <author-media-card
        v-for="card in cards"
        :key="card.key"
        :card="card"
      />
    </div>
  </section>
</template>

<script>
import AuthorMediaCard from '@/components/author/AuthorMediaCard.vue';

export default {
  name: 'AuthorContentSection',
  components: {
    AuthorMediaCard,
  },
  props: {
    headingId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    cards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.author-content-section {
  min-width: 0;
  padding: 16px;
  background: var(--author-surface);
  border: 1px solid var(--author-border);
  border-radius: var(--author-radius);
  box-shadow: var(--author-shadow);
}

.author-content-section__header {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--author-border);
}

.author-content-section__title {
  margin: 0;
  color: var(--author-foreground);
  font-family: 'Bangers', cursive;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0.04em;
  text-wrap: balance;
}

.author-content-section__count {
  margin-left: 8px;
  color: var(--author-muted);
  font-family: var(--home-font-body, 'Roboto', sans-serif);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: normal;
}

.author-content-section__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  min-width: 0;
}

@media (min-width: 640px) {
  .author-content-section {
    padding: 24px;
  }

  .author-content-section__title {
    font-size: 20px;
  }

  .author-content-section__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {
  .author-content-section__grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .author-content-section__grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
</style>
